import React, { Component } from "react";
import { CardElement, injectStripe } from "react-stripe-elements";
import SubscriptionOverview from "./subscription-overview";

class CheckoutForm extends Component {
  constructor(props) {
    super(props);
    this.submit = this.submit.bind(this);
  }

  validateForm = async () => {
    const { form } = this.props;
    if (
      form.company_name &&
      form.agency_name &&
      form.street &&
      form.postalcode &&
      form.city &&
      form.country &&
      form.email &&
      form.first_name &&
      form.last_name
    ) {
      return true;
    }
    return false;
  };

  async submit(ev) {
    const { form } = this.props;
    this.props.setLoading(true);

    let validate = await this.validateForm();

    if (validate) {
      let { token } = await this.props.stripe.createToken({ name: "Name" });
      if (!token) {
        this.props.setLoading(false);
        return;
      }
      const stripe_subscription = `agency_${this.props.accountPackage}_${this.props.paymentInterval}ly_2022`;
      const data = {
        token: token.id,
        stripe_subscription,
        coupon_code:
          this.props.paymentInterval === "month" ? form.coupon_code : "",
        how_did_you: form.how_did_you,
        agency: {
          title: form.agency_name,
          vatnr: form.tax_number,
          street: form.street,
          postalcode: form.postalcode,
          city: form.city,
          country: form.country,
        },
        billing: {
          name: form.agency_name,
          vat_number: form.tax_number,
          street: form.street,
          postal_code: form.postalcode,
          city: form.city,
          country: form.country,
        },
        agency_user: {
          name_first: form.first_name,
          name_last: form.last_name,
          email: form.email,
        },
      };
      let response = await fetch("https://api.a-boss.net/trials_agency", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      });

      if (response.ok) {
        this.props.setLoading(false);
        this.props.setSetup(true);
      } else {
        this.props.setLoading(false);
        this.props.setCardNotice(
          "There has been an issue while trying to process your card"
        );
      }
    } else {
      this.props.setError(true);
      this.props.setLoading(false);
    }
  }

  render() {
    return (
      <div className="checkout">
        <CardElement style={{ base: { color: "#fff" } }} />
        <SubscriptionOverview {...this.props} />
        <p>
          By signing up for an ABOSS Agency subscription you agree to the{" "}
          <a
            href="https://aboss.notion.site/Terms-Agency-763e476c6c6f4a4aad121f4ff81ad5e5"
            target="_terms"
          >
            terms & conditions
          </a>{" "}
          and agree on a returning creditcard charge without further notice and
          cancelation.
        </p>
        {this.props.errorState && (
          <div className="aboss__signup-agency-form-error">
            Please fill in all required fields
          </div>
        )}
        {this.props.cardNotice && (
          <div className="aboss__signup-agency-form-error">
            {this.props.cardNotice}
          </div>
        )}
        <div className="aboss__signup-agency-form-action">
          {!this.props.loadingState && (
            <button onClick={this.submit}>Sign up</button>
          )}
          {this.props.loadingState && (
            <button>Setting up your account...</button>
          )}
        </div>
      </div>
    );
  }
}

export default injectStripe(CheckoutForm);



// WEBPACK FOOTER //
// src/views/sign-up-agency/check-out-form.js